import { useEffect, useState } from "react";

declare global {
  interface Window {
    debugMode: boolean;
  }
}

const useDebugMode = () => {
  const [debugMode, setDebugMode] = useState(window.debugMode || false);

  useEffect(() => {
    const handleDebugModeChange = () => {
      setDebugMode(window.debugMode);
    };

    document.addEventListener("debugModeChange", handleDebugModeChange);

    return () => {
      document.removeEventListener("debugModeChange", handleDebugModeChange);
    };
  }, []);

  return debugMode;
};

export default useDebugMode;
